

import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, of, Subject, throwError } from "rxjs";
import { tap, catchError, map } from 'rxjs/operators';
import { environment } from "src/environments/environment";
import { AuthService } from 'src/app/services/auth.service';

@Injectable({providedIn:'root'})
export class KeycloakAuthService{
    loggedIn$ = new BehaviorSubject(false);
    lid: number = 214601;
    lidSub= new Subject<number>();
    constructor(
        private httpClient: HttpClient,
        private router:Router,
        private authService: AuthService
    ) {
        this.syncLoggedInState();
    }

    private syncLoggedInState(): void {
        const loggedIn = this.authService.isLoggedIn();
        this.loggedIn$.next(loggedIn);
    }

    private setLoggedIn(loggedIn: boolean): void {
        this.loggedIn$.next(loggedIn);
        this.authService.loggedIn$.next(loggedIn);
    }
    // http://localhost:4200/
    signInWithSocial(socialType:string, appUrl:string='https://se2.tech/'){
         return this.httpClient.get(`${environment.loginApi}keycloak/authorization/`+ `${socialType}?redirect_uri=${appUrl}oauth/callback`,
            { responseType: 'text' as 'json' }
         ).pipe(
            tap((responce)=>{
                return responce
            })
        )
    }

    login(loginForm:{password:string, email:string}): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            "Authorization": 'Bearer {{token}}'
        });

        let options = {
            headers: headers,
            responseType: 'text' as 'json'
        }
        console.log('environment.loginApi', environment.loginApi);
        return this.httpClient.post(`${environment.loginApi}keycloak/`+ `login?email=${loginForm.email}&password=${loginForm.password}`, null, options,
        ).pipe(
            tap((response: any) => {
                if (response?.error || response?.error_description) {
                    return;
                }
                if (response) {
                    localStorage.setItem('token', response);
                    this.setLoggedIn(true);
                }
            }),
            catchError((error) => {
                return throwError(() => this.normalizeHttpError(error));
            })
        );
    }

    private normalizeHttpError(error: any): { errorMessage: string } {
        if (typeof error?.errorMessage === 'string') {
            return { errorMessage: error.errorMessage };
        }

        if (!error || error.status === 0) {
            return { errorMessage: 'NETWORK_ERROR' };
        }

        const loginMessage = this.getLoginErrorMessage(error?.error);
        if (loginMessage) {
            return { errorMessage: loginMessage };
        }

        const registrationMessage = this.getRegistrationErrorMessage(error?.error);
        if (registrationMessage) {
            return { errorMessage: registrationMessage };
        }

        if (typeof error?.message === 'string' && error.message) {
            return { errorMessage: error.message };
        }

        return { errorMessage: 'REQUEST_FAILED' };
    }

    private getLoginErrorMessage(source: unknown): string | null {
        if (!source) {
            return null;
        }

        if (typeof source === 'object') {
            const obj = source as {
                error_description?: string;
                errorMessage?: string;
                message?: string;
                error?: string;
            };
            if (obj.error_description) {
                return obj.error_description;
            }
            if (obj.errorMessage) {
                return obj.errorMessage;
            }
            if (obj.message) {
                return obj.message;
            }
        }

        if (typeof source === 'string') {
            try {
                return this.getLoginErrorMessage(JSON.parse(source));
            } catch {
                return source;
            }
        }

        return null;
    }

    private getRegistrationErrorMessage(source: unknown): string | null {
        if (!source) {
            return null;
        }
        const text = typeof source === 'string'
            ? source
            : (source as { message?: string }).message ?? JSON.stringify(source);

        if (!text.includes('errorMessage')) {
            return null;
        }
        const jsonStart = text.indexOf('{');
        try {
            const parsed = JSON.parse(text.substring(jsonStart));
            return parsed.errorMessage ?? null;
        } catch {
            return null;
        }
    }

    registration(loginForm:{ email:string, password:string}): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            "Authorization": 'Bearer {{token}}'
        });

        let options = {
            headers: headers,
            responseType: 'text' as 'json'
        }
        return this.httpClient.post(`${environment.loginApi}keycloak/`+ `register?email=${loginForm.email}&password=${loginForm.password}`, null, options).pipe(
            catchError((error) => {
                const registrationMessage = this.getRegistrationErrorMessage(error?.error);
                if (registrationMessage) {
                    return of({ errorMessage: registrationMessage });
                }
                return throwError(() => this.normalizeHttpError(error));
            }),
            map((response: any) => {
                if (response?.errorMessage) {
                    return response;
                }
                const errorMessage = this.getRegistrationErrorMessage(response);
                return errorMessage ? { errorMessage } : response;
            }),
            tap((response: any) => {
                if (response?.errorMessage) {
                    return;
                }

                console.log('registration successfully, id:', response);
                this.login(loginForm).subscribe(token => {
                    if (typeof token !== 'undefined' && token && token !== 'null') {
                        const pendingAction = localStorage.getItem('postLoginAction');
                        if (pendingAction) {
                            const { type, path, appInfo } = JSON.parse(pendingAction);
                            localStorage.removeItem('postLoginAction');
                            if (type === 'CREATE_LXC') {
                                this.router.navigate([path], {
                                    state: { appInfo, type }
                                });
                                return;
                            }
                            if (type === 'STRIPE_PAYMENT') {
                                this.router.navigate([path], {
                                    state: { appInfo, type }
                                });
                                return;
                            }
                        }
                        this.router.navigate(['/']);
                    }
                });
            })
        );
    }
    //test http://localhost:4200/
    requestToken(appUrl:string='https://se2.tech/', state:string, code:string){
        return this.httpClient.get(`${environment.loginApi}oauth/callback?session_state=${state}&code=${code}&redirect_uri=${appUrl}oauth/callback`,
            { responseType: 'text' as 'json' }
        ).pipe(
            tap((res:any)=>{
                console.log('res token', res);
                localStorage.setItem("token", res);
                this.setLoggedIn(true);
                return res
            })
        )

    }
}
